import Vue from 'vue'
// import AppVue from '../App.vue'
// import IndexVue from '../index.vue'
import Router from 'vue-router'
Vue.use(Router);

let newRouter;
const W = window,
  routes = [],
  $Post = W.$Post,
  $forObj = forObj,
  $myClone = myClone,
  $myRange = myRange,
  hideProperty = A.hideProperty,
  $define = W.Object.defineProperty,
  $Types = ['then', 'catch', 'finally'],
  Englishmenus = W.$Menus && W.$Menus.Englishmenus,
  $Routerpaths = W.$Routerpaths = { __proto__: null },
  $Routers = W.$Routers = W.$Routers || { __proto__: null }, Reto = { __proto__: null };
// console.error($Post,888888888);

const Import = (files, parsefn, pointpath, vuepage) => {
  for (pointpath of files.keys()) {
    // if ( pointpath.includes('MyMenu') ) continue;
    if (pointpath.includes('.test.')
      || pointpath.includes('.local.')
      || pointpath.includes('.old.')
      || pointpath.includes('.bak.')
    ) continue;
    parsefn((vuepage = files(pointpath)).default || vuepage, pointpath);
  };
};

const RouterMetas = $Routers.$metas = {
  __proto__: null,
  rootpage: '', // 根url地址的页面 - 通常是登录页
  homepage: '', // 进入app之后的首页
};
hideProperty($Routers, '$metas');
// A.import( require.context( '../views/',true,/\.vue$/ /*,'lazy'*/ ), (obj,path)=>[obj,path] );
Import(require.context('../views/', true, /\.vue$/ /*,'lazy'*/), newRouter = (_, obj, path, iscomp) => {
  // if( obj === './index.vue' ) return ;
  // console.error(_,obj,path);
  !path ? [obj, path] = [_, obj.slice(1, -4)] : path = iscomp = _ + path.slice(1, -4);

  let name, index;
  name = path.slice(index = path.lastIndexOf('/') + 1);

  if (name[0] === '$') {
    // name = ( name + '.' ).slice( 0, name.indexOf('.') );
    obj.path = path;
    Vue.use(
      (function (name, obj, Vue) {
        Vue.component(name, obj);
      }).bind(null, obj.render.componentName = (name + '.').slice(0, name.indexOf('.')).slice(1).toLowerCase(), obj)
    );
    if (iscomp)
      return;
  };

  // $Routerpaths[ path ] = true;

  let isame = false, redirect, Route, ini = path.slice(0, index);
  let meta = (obj.render || []).meta = {
    __proto__: null,
    fpath: '',
    loaded: 0,
    // get $Gorootpage(){
    //   return this.$$Gorootpage;
    // },
    // set $Gorootpage(n) {
    //   ( this.$$Gorootpage = n ) && (
    //     App.Gorootpage()
    //   );
    // }
  };
  name[0] === '$' && (name = name.slice(1));
  if ((Route = name.indexOf('.')) > -1) {
    let metaProp = name.slice(Route + 1).split('.'), toggle = meta.toggle = { __proto__: null };
    Route = name.slice(0, Route);
    path = path.slice(0, Route.length - name.length);
    name = Route;
    // console.error( name, path );
    for (metaProp of metaProp) {
      metaProp = metaProp.toLowerCase();
      metaProp.startsWith('toggle')
        ? (toggle[metaProp = metaProp.slice(6)] = name, meta[metaProp] = name)
        : (meta[metaProp] = name);
      RouterMetas[metaProp] !== void 0 && (RouterMetas[metaProp] = path);
    };
    // path = path.slice(0,-Route);
  };
  meta.fpath = path;

  let config = {
    __proto__: null,
    name: '',
    path: '',
    component: obj,
    meta: meta,
  };

  // console.error(name); //obj,ini,path
  // !path.includes('Background') && console.error( obj );
  if (
    name[0] === '#' ? ([name, redirect] = name.slice(1).split('@'), isame = null, true) 
    : name.includes('@') === false ? isame = path.includes('/' + name + '/') 
    : ([name, redirect] = name.split('@'), true)
  ) {
    // console.error( path.slice( 0, path.lastIndexOf('/',index-1)) );
    (Route = $Routers[path.slice(0, path.lastIndexOf('/', index - 1))])
      ? (Route = Route.children, config.parent = ini || '/')
      : Route = 0; //routes;

    // console.error(name,redirect,Route);
    redirect
      ? (Reto[config.redirect = redirect = ini + '/' + redirect] = config, routes.push({ path, redirect }))
      : isame && routes.push({ path, redirect: ini || '/' + name });

    // console.error(name, ini, path, config);
    config.path = ini = isame === null && !redirect ? '/' + name : ini || '/' + name;

    ($Routers[ini] = config).children = [];

  } else {
    (Route = $Routers[ini = ini || '/' + name])
      ? (Route = Route.children, config.path = name, config.parent = ini)
      : (Route = 0, config.path = path);

    $Routers[path] = config;
  };
  // console.error(ini,path);

  // console.error(name,obj);
  // ( config.name = name )[0] !== '$' && ( obj.name = name );

  // config.path = '..' + config.path;
  $Routerpaths[config.fpath = path] = config;

  // $BindPageApis(obj,name,path);
  path = config.path;
  obj.name = config.name = config.meta.name = name;
  // console.error(name, path);
  (obj = Englishmenus[name] || Englishmenus[path]) && (
    obj.routeName = name,
    obj.routePath = path,
    hideProperty(obj, "routeMeta", meta),
    hideProperty(obj, "routeComp", config),
    config.menuConfig = obj,
    (obj.show === false || (ini = obj.parent) && ini.show === false || (ini = ini.parent) && ini.show === false)
    && (Route = false, delete $Routers[path], delete $Routerpaths[config.fpath], delete Reto[config.redirect])
  );

  Route && Route.push(config);

  // console.error(name,obj,arguments.length);
  // return path;
});
Import(require.context('../components/', true, /\.vue$/ /*,'lazy'*/), newRouter.bind(null, '/components'));
// console.error($Routerpaths,routes,$Routers,Reto);
// console.error('Router.js导入完成',11111111111, Englishmenus);

forObj($Routers, (obj, path, C) => {
  // console.error(path,!obj.parent);
  // console.error( obj, path, $Routers );
  (C = Reto[path]) && C.redirect !== path
    ? C.children.push(obj)
    : !obj.parent && !path.startsWith('/components/') && routes.push(obj);

  /*: !obj.parent && !path.startsWith('/components/') && ( 
    // ( obj.children )  && path !== '/index'
    // console.warn( path, ( !path.slice(1).includes('/') && path !== '/index' ) ),
    !obj.fpath.slice(1).includes('/') || path === '/index' // /login /other
    ? routes
    : ( C = $Routers['/index'] ).children || ( C.children = [] ) 
  ).push( obj );*/

});
// <router-link to='index' tag="li" event="mouseover">
// 文件名参考 #center@Center={meta：true，active：false}.vue
export default newRouter = W.$Newrouter = W.r = new Router({
  mode: 'hash',//hash模式下，浏览器地址不规整,带有#
  // mode: 'history',//history模式下，浏览器地址规整，但需要后台支持
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: RouterMetas.rootpage //重定向
    },
    // {
    //   name: 'index',
    //   path: '/index',
    //   fpath: '../index',
    //   component: IndexVue,
    //   redirect: RouterMetas.rootpage,
    //   meta: {
    //     name: 'index',
    //     fpath: '../index',
    //     keepAlive: true,
    //   },
    //   children: routes

    // },
    ...routes
  ]
});

/*W.myBind("App",App=>{
  // console.error(root);
  App.$watch('$route', to=>{
    // console.error(to);
    const path = to.path;
    to = (to.matched||[]).find(vue=>vue.path===path);
    W.w = to && ( to = to.instances ) && to.default;
    // console.error(to);
  },{immediate: true});
  return delete W.App, W.App = App;
});*/

W.myBind('w', (old, oold) => {
  var to = App.$route, path = to.path;
  to = (to.matched || []).find(vue => vue.path === path || vue.path + '/' === path);
  return to && (to = to.instances) && (oold.old = to.default) || false;
}, 0, 'getter');

const push = newRouter.push, replace = newRouter.replace;
newRouter.push = function (location, onComplete, onAbort) {
  const next = push.call(this, location, onComplete, onAbort);
  return next && next.catch(err => err);
};
newRouter.replace = function (location, onComplete, onAbort) {
  const next = replace.call(this, location, onComplete, onAbort);
  return next && next.catch(err => err);
};

const $Vue = Vue.prototype, Now = W.Date.now;
// this.$push('login') | this.$push('/login') | this.$push({name:'login',path:'/login'})
$Vue.$push = function (menu, refresh) {
  if (!menu) return;
  var name, path, $route = this.$route, $routepath = $route.path, $routename = $route.name, $meta = $route.meta, isKeep = $meta.notkeepAlive;
  $meta.gotoMode = '$push';
  // console.error( menu, $route, typeof menu );
  this.$router.push(typeof menu === 'object'
    ? { path: path = menu.path/*,name: name=menu.name*/ }
    : !menu.includes('/')
      ? { name: name = menu }
      : (menu[0] !== '/' && (menu = '/' + menu), { path: path = menu }),
    (to, _meta, path) => {
      // console.warn( 111111, to );
      // $meta.gotoMode = '';
      _meta = to.meta;
      if (_meta.notkeepAlive || _meta.loaded < 2) return;
      path = to.path;
      // console.warn( 88888888, to, to.matched, to.matched.find(t=>t.path===path), path );
      to.matched && (to = to.matched.find(t => t.path === path || t.path + '/' === path));
      if (!to) return;
      // console.warn( to, 5555555, _meta.loaded, to.instances, to.instances.default );
      _meta.ismenu && (to = to.instances.default) && refresh !== 'refresh'
        ? ($Routers[path].component.created||(()=>{})).call(to)
        : (
          $meta.gotoMode = '',
          $refresh(),
          console.error('登录之后强制刷新....', to)
        );
      // console.error( to, $meta.ismenu, 200000000000 );
    }
  );

  ($routename === name || $routepath === path) && (
    // isKeep && ( $meta.notkeepAlive = '' ),
    // Root.activeDate = App.activeDate = Now(),
    // isKeep && ( $meta.notkeepAlive = isKeep )
    $meta.gotoMode = refresh = '',
    $refresh(),
    console.error('相同路由....')
  );
  // console.error(menu, $meta, name,path);
  return { name, path };
};
const $refresh = W.$refresh = () => {
  // return App.activeDate = Now();

  const meta = App.$route.meta;
  meta.notkeepalive
    ? App.excludeKey = meta.key = '$' + Now()
    : (
      meta.refresh = true,
      App.activeDate = Now()
    );
  // Root.activeDate = App.activeDate = Now();
};

console.log('I am Router.js');

/*newRouter.beforeEach((to, from, next) => {
    // console.warn(to,from);
    if( !$Routerpaths[to.path] ) return newRouter.replace({name: 'login'});
    next();
});*/

// console.error(newRouter);
/*newRouter.afterEach((to, from) => {
    console.warn(to.matched[0].instances,from);
});*/

/*'/user': { // '/user@Background' [ '', user, #user@Background ]
  children: [ ],
  name: 'user',
  path: '/user',
  redirect: '/user/Background',
  meta: {
    active: true,
  }
},
'/user/center': { // '/center@Center' [ '', user, center, #center@center ]
  children: [ ],
  name: 'center',
  path: '/user/center',
  redirect: '/user/center/Center',
  meta: {
    active: true,
  }
},*/
















































/*const $BindPageApis = (obj,name,path,config)=>{
  if( !( config = Englishmenus[name] || Englishmenus[path] )) return false;
  // console.error(obj);
  config.rpath = path;

  const timers = new W.Set();
  timers.putt = cc=>{
    // console.warn(44444,timers.size,cc.showName,timers.istart, timers.timer);
    // alert('清除..');
    // timers.istart === '下次前清空' && ( timers.istart = null );
    timers.istart = true;
    W.clearTimeout(timers.timer);
    // W.clearTimeout(timers.timerest);
    // console.error("计时器链式调用...", timers.size, [ timers.istart, timers.ifrist ]  );
    // if( timers.ifrist === 1 )
    timers.timer = W.setTimeout(timers.async,0);
    // console.error('计时器putt::',timers.timer);
    cc.lastRes = true;
    timers.add( cc );
    // console.warn( '........', timers, timers.size );
    return cc;
  };
  timers.async = async (call,res)=>{
    // if( timers.size < 2 ) return timers.clear();
    // console.warn(1111111, timers.size,timers);
    if( timers.size > 0 ) {
      // timers.istart = true;
      // console.warn(timers.size);
      for( call of timers ) {
        // alert(call.showName+timers.size);
        console.error('开始下一个', call.getter,call.showName,timers.size, [ res ]);
        if( call.getter === 'ignore' || call.getter === 'ignorefirst' ) continue;
        call.getter = null;
        if( res !== '$$_BREAK_$$' ) {
          res = call.lastRes = await call.$next();
          !res && ( res = '$$_BREAK_$$' );
        };
        // await sleep(3000);
        // console.error('下一个',res,call.showName);
        // if( res === false ) break;
      };
      if( res !== '$$_BREAK_$$' ) {
        timers.success.forEach(f=>f());
      };
      timers.finallys.forEach(f=>f());
    };
    // alert(5555);
    // console.error([timers.finallys[0]],res);
    // await sleep(200);
    timers.clearAll();
  };
  timers.finallys = [], timers.success = [];
  timers.clearAll = (clearFor)=>{
    if( clearFor )
      timers.forEach($=>$.getter = null);
    timers.clear();
    timers.istart = timers.ifirst = void 0;
    timers.finallys.length = 0;
    timers.success.length = 0;
  };

  // console.error(Englishmenus);
  // obj.xxx = 7777;
  // const initData = obj.data;
  // console.warn(this);
  let apimethods = obj.render;
  if( !apimethods ) return;
  apimethods = apimethods.apimethods = {};

  // name === 'SecondClass' && console.error(obj,name,path,config);

  config.hideProperty( 'created', function(self){
    // console.error(55555555, self, obj, apimethods);
    // timers.clear(), timers.istart = timers.ifirst = void 0, timers.success.length = timers.finallys.length = 0;
    // // self.with(apimethods);
    // $forObj(apimethods,(ges,name,template)=>{
    //   template = ges.template;
    //   template.this = self, template.getter = null, template.args = null, template.lastRes = true;
    //   template[$Types[1]+'Callback'] = template[$Types[0]+'Callback'] = template[$Types[2]+'Callback'] = false;
    //   $define( self, name, ges );
    //   // console.error(self,name,ges);
    // });
    // console.error(self.$options.apidata,obj);
    // !config.$apidata && config.hideProperty( '$apidata', self.$options.apidata );
  } );

  // ( obj.beforeCreate || ( obj.beforeCreate = [] ) ).unshift(function(){
    const fns = [], methods = obj.methods;
    // config.name === '二级分类' && console.error('beforeCreate::',obj,this, config);
    $forObj( config.api, (params,name)=>{
      // console.error(name);
      if( methods[name] !== void 0 ) return;
      // console.error( name, params, this );

      return;
      const template = function(){
        // console.warn(name,arguments);
        // console.error(name, template.getter, timers.istart, timers);
        // if( fns.length++ > 10 )
        //   return false;
        W.currentFn = self.currentFn = template;
        var ref = template.this.$refs[name]||0;
        if( ref.$$path === 'ElForm' ) {
          // console.error(ref,name);
          if( !ref.$el.offsetParent ) return timers.clearAll(true),false;
          template.$next2 = (async ()=>await ref.validate().catch(e=>e));
        };
        // console.warn(arguments.length, arguments[1], arguments[0] );
        template.args = arguments.length === 0
          ? null
          : arguments[0] && arguments[0].srcElement
          ? $myRange(arguments,1)
          : typeof arguments[0] === 'object' && (
              ref = [ arguments[1], arguments[0] ],
              ref
          );
        // console.error(name,timers.istart,timers);
        // console.warn('前面直接查询next??',template.showName, timers.istart, typeof getter, [ getter ] );
        if( typeof template.getter === 'function' ) return timers.putt( template );
        // console.error('ignore直接查询next??', template.showName, template.lastRes, [template.getter], timers.istart );
        template.getter =
          timers.istart
          ? 'ignore'
          : ( timers.istart = timers.ifirst = 1, 'ignorefirst' );
        // console.warn('ignore直接查询next??', template.showName, template.lastRes, [template.getter], timers.istart, timers );
        template.$next();
        return template;
      };
      template.this = this, template.showPath = path;
      //  template.getter = null, template.args = null, template.lastRes = true;
      template.isViewvue = true, template.showName = name;
      template.$nextTick = function(call,data){
        const self = template.this;
        const nextTick = async (v)=>{
          // console.error(template.lastRes);
          if( !template.lastRes ) return false;
          await self.$nextTick();
          // console.error(call,data);
          switch( typeof call ){
            case 'string': if( !(v = self[call]) ) break; call = v;
            case 'function': arguments.length > 1 ? call.call(self,data) : call.call(self);
          };
          await sleep(200);
          // console.error(call,[call]);
          res.thenCall && res.thenCall.call(self);
        };
        let res;
        timers.success.push(nextTick);
        return res = { then(call){ return res.thenCall = call, template; } };
      };
      template.$next = async function(){
        // console.error(1000,template.lastRes,timers);
        // return name !== 'yyy';
        const self = template.this;
        if( !template.lastRes ) return timers.clearAll(true), false;
        // template.getter = null;
        if( template.$next2 && !await template.$next2(template.$next2=false) ) return timers.clearAll(true), template.getter = false;
        // console.error( template.args );
        let params, args, temp;
        // ( temp = self.$getApiParams ).currentFn = template;
        // console.error(1111111,2222222222,document.readyState);
        // console.error(1111111,name, self.$getApiParams(name,'')[0]);
        // return;
        params = self.$getApiParams(name,''), args = [ ...template.args||[''], ...arguments ];
        template.args = null;
        // console.error(name,params,args, args[0], params[1].with(args[1]));
        // const res2 = await sleep(100);
        // console.error(55555, params, args);
        // return true;
        W.currentFn = self.currentFn = template;
        let selfData = self[ temp = name + '_data' ];
        // console.warn('计时器开始了吗?',timers.istart);
        // console.error( 22222222, params[0], params );
        let res = await ( $Post||W.$Post)( params[0], selfData.$$lastparams = params[1].with(args[1]), ...(args[0]=params[2]||args[0]||'',args) );
        // console.error('计时器开始了吗?',timers.istart);

        const Next = ()=>{
          template.getter = false;
          self.$lastResponse = ( W.currentFn = self.currentFn = res.currentFn = template ).response = res, res.selfargs = args;
          res.isuccess && (
            // console.error(res.data.data),
            selfData = self[ temp ] = $myClone( selfData ).with( res.data )
          );
          selfData.hideProperty('$$lastres',res);
          selfData.hideProperty('$$lastparams',res.params);

          // self[ name + '_data'] = res.ierror ? {} : res.data;
          // console.error(res);
          if( res.ierror ) { // 失败后的回调errorcallback
            template[$Types[1]+'Callback'] && template[$Types[1]+'Callback'](res,self,template,false);
          } else { // 成功后的回调successcallback
            template[$Types[0]+'Callback'] && template[$Types[0]+'Callback'](res,self,template,false);
          };
          template[$Types[2]+'Callback'] && template[$Types[2]+'Callback'](res,self,template,false); // 成功或失败都要触发的回调finallycallback
          template[$Types[1]+'Callback'] = template[$Types[0]+'Callback'] = template[$Types[2]+'Callback'] = false;
        };

        // console.error('啦啦啦啦阿联', template.showName, template.getter, timers.istart);
        if( timers.istart === true ) {
          if( template.getter === 'ignore' ) {
            // console.error( "哈哈哈哈哈哈哈哈哈", template.showName, template.getter, timers.istart );
            timers.finallys.push(Next);
            return true;
          };
        } else if( res ) {
          // W.setTimeout(timers.clearAll,0);
          timers.istart = '下次前清空';
        };

        Next();
        return res.ierror ? ( timers.clearAll(true), false ) : res;
      };
      template.$form = function(){
        // console.error(99999999999);
        template.$nextTick( $=>{
          template.this.$form(...arguments);
          // console.error(arguments,89999999999);
        } );
        return template;
      };
      template.$trigger = function(eventName){
        // const self = template.this;
        template.$nextTick(f=>{
          template.this.$trigger(...arguments);
        });
        return template;
      };
      $Types.forEach(type=>template[type] = call=>(template[ type + 'Callback' ] = call,template));
      fns.push( template );

      let isSelf = false;
      apimethods[name] = {
        template: template,
        configurable: true,
        get() {
          if( isSelf ) return isSelf;
          console.warn('getter: ',this, name, timers.istart, [template],timers);
          timers.istart === '下次前清空' && ( timers.clearAll(true) );
          template.lastRes = true;
          template.getter = template.this;
          // console.error('链式调用查询??', template.showName, timers.istart );
          // return timers.istart ? template : timers.putt( template );
          // timers.istart = true;
          return template;
        },
        set(New) {
          return isSelf = New;
        }
      };

    }  );

    // console.error(fns);

    // fns.forEach(t=>{
    //   fns.forEach(f=>{
    //     if ( f !== t )
    //       $define(t,f.showName,{
    //         get(){
    //           timers.istart === '下次前清空' && ( timers.clearAll(true) );
    //           f.lastRes = true;
    //           f.getter = this;
    //           console.error('链式调用查询??',f.showName, timers.istart, '调用者??', this.showName, [ f.getter ] );
    //           // f.this.currentFn = f;
    //           // return timers.istart ? timers.putt(f) : timers.putest( f );
    //           return timers.putt(f);
    //         }
    //       });
    //   });
    // });
    // console.error(fns);
  // });

  // console.error(obj,name,path,config);
};*/


// WEBPACK FOOTER //
// ./src/router/router.js